import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

// Components
import * as icons from '../Icons/Icons';

const Notification = observer(class Notification extends React.Component {
  constructor() {
    super();
    this.autoClose = this.autoClose.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
  }

  componentWillMount() {
    this.state = {
      closing: false
    }
  }

  componentDidMount() {
    const _this = this;

    this.autoClose();

    const notify = document.querySelector('.notify');

    // Delay close if hovered
    notify.addEventListener('mouseenter', function(){
      clearTimeout(_this.closeTimer);
    });

    // Restart close timer on mouse leave
    notify.addEventListener('mouseleave', function(){
      _this.autoClose();
    });
  }

  autoClose() {
    const _this = this;

    this.closeTimer = setTimeout(function(){
      _this.closeNotification();
    }, 10000);
  }

  closeNotification(e) {
    if(e) {
      e.preventDefault();

      if(e.target.href) {
        this.props.routing.history.push(e.target.href.replace('#/', ''));
      }
    }

    const { SessionStore } = this.props.store;

    this.setState({
      closing: true
    });

    clearTimeout(this.closeTimer);

    // Wait for animation to finish before removing
    setTimeout(function(){
      SessionStore.closeNotification();
    }, 250);
  }

  render() {
    const { SessionStore } = this.props.store;

    return(
      <div
        className={`
          notify
          ${this.state.closing ? 'notify--closing' : ''}
          ${SessionStore.notificationClass}
        `}
      >
        {SessionStore.notificationLink &&
          <Link
            className="notify__msg"
            to={SessionStore.notificationLink}
            onClick={(e) => this.closeNotification(e)}
          >
            {SessionStore.notificationContent}
          </Link>
        }

        {!SessionStore.notificationLink &&
          <span className="notify__msg">
            {SessionStore.notificationContent}
          </span>
        }

        <a
          href="#app"
          className="notify__close"
          onClick={(e) => this.closeNotification(e)}
        >
          <icons.iconTimes />
          <span className="meta">Close</span>
        </a>
      </div>
    );
  }
})

export default Notification;



// WEBPACK FOOTER //
// ./src/app/components/Common/Notification.js